import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-small"]
const _hoisted_2 = { class: "VoteSet__party" }
const _hoisted_3 = {
  key: 0,
  class: "VoteSet__municipality"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "VoteSet__votes" }

import { computed, PropType } from "vue";
import { VoteSet, VoteSetHeavy, VoteSetHeavyWithDistance } from "@/types";
import { useMainStore } from "../../stores/main";
import { addDotsToNumber } from "@/tools/format";


export default /*@__PURE__*/_defineComponent({
  __name: 'VoteSet',
  props: {
    voteSet: {
        type: Array as PropType<
            VoteSet | VoteSetHeavy | VoteSetHeavyWithDistance
        >,
        required: true,
    },
    isHeavy: {
        type: Boolean,
        default: false,
    },
    hideMunicipality: {
        type: Boolean,
        default: false,
    },
    small: {
        type: Boolean,
        default: false,
    },
    showDistance: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const store = useMainStore();
const props = __props;

const municipalityTitle = computed(() => {
    let m;
    if (props.isHeavy) {
        m = props.voteSet[1];
    } else {
        m = store.municipalities.find((m) => props.voteSet[1] === m.cbs_code);
    }
    return m ? m.title : "";
});

const party = computed(() => {
    if (props.isHeavy) {
        return props.voteSet[2];
    } else {
        return store.parties.find((p) => props.voteSet[2] === p.id);
    }
});

const partyTitle = computed(() => {
    return party.value ? party.value.name : "";
});

const partyColor = computed(() => {
    return party.value ? party.value.color : "";
});

const votes = computed(() => {
    return addDotsToNumber(props.voteSet[3]);
});

const distance = computed(() => {
    if (props.showDistance && props.voteSet.length > 4) {
        return Math.round(props.voteSet[4] * store.cellDistance) + "km";
    } else {
        return "";
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "VoteSet",
    "data-small": __props.small
  }, [
    _createElementVNode("div", {
      class: "VoteSet__color",
      style: _normalizeStyle({ backgroundColor: partyColor.value })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, _toDisplayString(partyTitle.value), 1),
    (!__props.hideMunicipality)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(municipalityTitle.value) + " ", 1),
          (__props.showDistance)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(distance.value) + ")", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, _toDisplayString(votes.value), 1)
  ], 8, _hoisted_1))
}
}

})